import { doPost } from './Api';

export default class SurveyService {
  static async saveSurvey(data) {
    const response = await doPost(`${process.env.REACT_APP_SAVE_SURVEY}`,data);
    return response.data;
  }
};
